// extracted by mini-css-extract-plugin
export var borderRadius = "_eq-4";
export var large = "_eq-3";
export var logoContainer = "_eq-0";
export var nameLogo = "_eq-2";
export var small = "_eq-1";